// /db/indexedDB.js
import { openDB } from "idb";

// Utility to consistently build a composite cache key
const buildKey = (code, subgroup) =>
  subgroup != null && subgroup !== "" ? `${code}:::${subgroup}` : code;

export const getDB = () =>
  openDB("DropdownDB", 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains("dropdowns")) {
        db.createObjectStore("dropdowns");
      }
      if (!db.objectStoreNames.contains("metadata")) {
        db.createObjectStore("metadata");
      }
    },
  });

// === DROPDOWN CACHE ===
export const getDropdown = async (code, subgroup) => {
  const db = await getDB();
  const key = buildKey(code, subgroup);
  return db.get("dropdowns", key);
};

export const saveDropdown = async (code, subgroup, data) => {
  const db = await getDB();
  const key = buildKey(code, subgroup);
  return db.put("dropdowns", data, key);
};

// === METADATA (TIMESTAMP) ===
export const getMetadata = async (code, subgroup) => {
  const db = await getDB();
  const key = buildKey(code, subgroup);
  return db.get("metadata", key);
};

export const saveMetadata = async (code, subgroup, updateTime) => {
  const db = await getDB();
  const key = buildKey(code, subgroup);
  return db.put("metadata", updateTime, key);
};
export const clearDropdownCache = async (code, subgroup) => {
  const db = await getDB();
  const key = buildKey(code, subgroup);
  await db.delete("dropdowns", key);
  await db.delete("metadata", key);
};
export const clearAllDropdownCache = async () => {
  const db = await getDB();
  await db.clear("dropdowns");
  await db.clear("metadata");
};
